import { useMemo, useState } from 'react';
import { icons, LucideIcon } from 'lucide-react';

interface EventTypeIconPickerProps {
  value: string;
  onChange: (iconName: string) => void;
}

const MAX_RESULTS = 120;

export const EventTypeIconPicker = ({ value, onChange }: EventTypeIconPickerProps) => {
  const [query, setQuery] = useState('');

  const iconNames = useMemo(() => {
    return Object.keys(icons).filter((name) => /^[A-Z]/.test(name));
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    const source = q ? iconNames.filter((name) => name.toLowerCase().includes(q)) : iconNames;
    return source.slice(0, MAX_RESULTS);
  }, [iconNames, query]);

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-brand-gray-dark">Icono (Lucide)</label>
      <input
        type="text"
        className="w-full"
        placeholder="Buscar icono, ej: trend, alert, pause..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <div className="max-h-60 overflow-y-auto border border-gray-200 rounded-md p-2 bg-white">
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
          {filtered.map((name) => {
            const Icon = icons[name as keyof typeof icons] as LucideIcon;
            const isSelected = value === name;
            return (
              <button
                key={name}
                type="button"
                onClick={() => onChange(name)}
                className={`p-2 rounded-md border text-xs flex flex-col items-center gap-1 ${
                  isSelected
                    ? 'border-brand-orange bg-orange-50 text-brand-orange'
                    : 'border-gray-200 hover:border-brand-orange'
                }`}
                title={name}
              >
                <Icon className="h-4 w-4" />
                <span className="truncate w-full">{name}</span>
              </button>
            );
          })}
        </div>
      </div>
      <p className="text-xs text-gray-500">
        Mostrando hasta {MAX_RESULTS} resultados. Seleccionado: <strong>{value || 'ninguno'}</strong>
      </p>
    </div>
  );
};
